"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewModeWrapper = exports.ViewModeSuffix = exports.ViewModePrefix = exports.ViewModeChildren = exports.StyledInputWrapper = exports.StyledInputSuffix = exports.StyledInputPrefix = exports.StyledInputGroup = exports.StyledInputAllowClear = exports.StyledInputAddonWrapper = exports.StyledInputAddon = exports.StyledInput = exports.CopyIcon = exports.CopyButtonWrapper = exports.CopyButton = exports.ChildrenWrapper = void 0;
var _ykbStyledComponents = _interopRequireWildcard(require("../ykb-styled-components"));
var _StyledButton = _interopRequireDefault(require("../Button/StyledButton"));
var _Button = _interopRequireDefault(require("../Button"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var getSize = function getSize(props) {
  return props.theme.input.sizes[props.size] || props.theme.input.sizes['medium'];
};
var StyledInput = exports.StyledInput = _ykbStyledComponents.default.input.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-0"
})(["position:relative;display:inline-block;padding:", " ", ";height:", ";font-size:", ";line-height:", ";color:", ";background-color:", ";};background-image:none;border:", ";border-radius:", ";transition:all 0.3s;min-width:", ";width:100%;&:focus,&.focused{outline:0;}", " ", " &::placeholder{color:", ";opacity:1;}&:-ms-input-placeholder{color:", ";}&::-ms-input-placeholder{color:", ";}&[type='password']{-ms-text-security:none;}&[type='password']::-ms-reveal,&[type='password']::-ms-clear{display:none;}&.readonly,&:read-only{border:0;box-shadow:none;}&::-ms-clear{display:none;}textarea&{max-width:100%;height:auto;vertical-align:bottom;transition:all 0.3s,height 0s;min-height:", ";}&:disabled,&.disabled{opacity:1;cursor:not-allowed;background-color:", ";border:1px solid ", ";color:", ";&:hover,&:focus{border-color:", ";box-shadow:'none';}}", " ", ""], function (props) {
  return getSize(props).paddingVertical;
}, function (props) {
  return getSize(props).paddingHorizontal;
}, function (props) {
  return getSize(props).height;
}, function (props) {
  return getSize(props).fontSize;
}, function (props) {
  return getSize(props).lineHeight;
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.theme.input.backgroundColorType[props.$backgroundColorType] || props.theme.input.backgroundColorType.default;
}, function (props) {
  return getSize(props).border;
}, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return props.theme.border.minWidth;
}, function (props) {
  return props.focusAll && (0, _ykbStyledComponents.css)(["&:focus,&.focused{border-top:0;border-bottom:1px solid ", ";}"], function (props) {
    return props.theme.input.hover.borderColor;
  });
}, function (props) {
  return !props.focusAll && (0, _ykbStyledComponents.css)(["&:hover{border-color:", ";}&:focus,&.focused{border-color:", ";outline:0;box-shadow:0 0 3px 3px ", ";border-right-width:1px;}"], function (props) {
    return props.theme.input.hover.borderColor;
  }, function (props) {
    return props.theme.input.focus.borderColor;
  }, function (props) {
    return props.theme.input.focus.boxShadowColor;
  });
}, function (props) {
  return props.theme.input.placeHolderColor;
}, function (props) {
  return props.theme.input.placeHolderColor;
}, function (props) {
  return props.theme.input.placeHolderColor;
}, function (props) {
  return getSize(props).height;
}, function (props) {
  return props.theme.input.disabled.backgroundColor;
}, function (props) {
  return props.theme.input.disabled.borderColor;
}, function (props) {
  return props.theme.input.disabled.color;
}, function (props) {
  return props.theme.input.disabled.hover.borderColor;
}, function (props) {
  return props.addonAfter && (0, _ykbStyledComponents.css)(["border-bottom-right-radius:0;border-top-right-radius:0;"]);
}, function (props) {
  return props.addonBefore && (0, _ykbStyledComponents.css)(["border-bottom-left-radius:0;border-top-left-radius:0;"]);
});
var StyledInputWrapper = exports.StyledInputWrapper = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-1"
})(["position:relative;display:inline-block;width:100%;&:hover{", "{span{display:block;}}}", "{position:static;&:not(:last-child){padding-right:", "px;}&:not(:first-child){padding-left:", "px;}}"], StyledInputAllowClear, StyledInput, function (props) {
  return 2 * getSize(props).iconMargin + props.theme.input.iconSize;
}, function (props) {
  return 2 * getSize(props).iconMargin + props.theme.input.iconSize;
});
var StyledInputPrefix = exports.StyledInputPrefix = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-2"
})(["left:", "px;position:absolute;top:50%;transform:translateY(-50%);line-height:0;color:", ";svg{font-size:", "px;color:", ";}"], function (props) {
  return getSize(props).iconMargin;
}, function (props) {
  return props.theme.input.color;
}, function (props) {
  return props.theme.input.iconSize;
}, function (props) {
  return props.theme.color.primary6;
});
var StyledInputSuffix = exports.StyledInputSuffix = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-3"
})(["right:", "px;position:absolute;top:50%;transform:translateY(-50%);line-height:0;color:", ";svg{font-size:", "px;color:", ";}"], function (props) {
  return getSize(props).iconMargin;
}, function (props) {
  return props.theme.input.color;
}, function (props) {
  return props.theme.input.iconSize;
}, function (props) {
  return props.theme.input.colorType[props.colorType] && props.theme.input.colorType[props.colorType].color || props.theme.color.primary6;
});
var StyledInputAllowClear = exports.StyledInputAllowClear = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-4"
})(["right:", "px;position:absolute;top:50%;transform:translateY(-50%);line-height:0;color:", ";display:none;&:hover{cursor:pointer;}svg{font-size:", "px;color:rgb(140,140,140);}"], function (props) {
  return getSize(props).iconMargin;
}, function (props) {
  return props.theme.input.color;
}, function (props) {
  return props.theme.input.iconSize;
});
var StyledInputAddonWrapper = exports.StyledInputAddonWrapper = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-5"
})(["display:inline-block;vertical-align:top;width:100%;"]);
var StyledInputGroup = exports.StyledInputGroup = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-6"
})(["position:relative;display:table;border-collapse:separate;border-spacing:0;width:100%;& > span{display:table-cell;}", " ", "{float:left;width:100%;margin-bottom:0;&:not(:last-child):not(:first-child){border-radius:0;}&:not(:last-child){border-bottom-right-radius:0;border-top-right-radius:0;}&:not(:first-child){border-bottom-left-radius:0;border-top-left-radius:0;}}.currency-dropdown{margin:", ";width:", ";font-size:", ";.editable-currency-dropdown{height:", " !important;min-height:", " !important;}.ykb-ui-select-selector{border:none !important;height:", " !important;min-height:", " !important;div{margin:0px !important;}}}"], function (props) {
  return props.focusAll && (0, _ykbStyledComponents.css)(["border-radius:", ";&:hover{border-color:", " !important;}&.focused{outline:0;box-shadow:0 0 3px 3px ", ";border-right-width:1px;> *{border-top:1px solid ", ";border-bottom:1px solid ", ";}> *:last-child{border-right:1px solid ", ";}> *:first-child{border-left:1px solid ", ";}}"], function (props) {
    return getSize(props).borderRadius;
  }, function (props) {
    return props.theme.input.hover.borderColor;
  }, function (props) {
    return props.theme.input.focus.boxShadowColor;
  }, function (props) {
    return props.theme.input.focus.borderColor;
  }, function (props) {
    return props.theme.input.focus.borderColor;
  }, function (props) {
    return props.theme.input.focus.borderColor;
  }, function (props) {
    return props.theme.input.focus.borderColor;
  });
}, StyledInput, function (props) {
  return props.theme.input.editableCurrency.margin;
}, function (props) {
  return getSize(props).editableCurrencyWidth;
}, function (props) {
  return getSize(props).editableCurrencyFontSize;
}, function (props) {
  return getSize(props).editableCurrencyHeight;
}, function (props) {
  return getSize(props).editableCurrencyHeight;
}, function (props) {
  return getSize(props).editableCurrencyHeight;
}, function (props) {
  return getSize(props).editableCurrencyHeight;
});
var StyledInputAddon = exports.StyledInputAddon = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-7"
})(["display:table-cell;width:1px;white-space:nowrap;vertical-align:middle;padding:0 ", ";font-size:", ";font-weight:", ";line-height:1;color:", ";text-align:center;background-color:", ";border:", ";border-radius:", ";position:relative;transition:all 0.3s;width:1px;", ";", "{border:0;margin:-1px -12px -1px -10px;padding:0 10px;.icon-wrapper{text-align:center;}&:focus{z-index:1;border-right-width:1px;}&:hover{z-index:1;border-right-width:1px;}&:not(:last-child){border-bottom-left-radius:0;border-top-left-radius:0;}&:not(:first-child){border-bottom-right-radius:0;border-top-right-radius:0;}}&:first-child{border-right:0;border-bottom-right-radius:0;border-top-right-radius:0;", "{border-radius:", " 0 0 ", ";}}&:last-child{border-left:0;border-bottom-left-radius:0;border-top-left-radius:0;", "{border-radius:0 ", " ", " 0;}}"], function (props) {
  return getSize(props).paddingHorizontal;
}, function (props) {
  return getSize(props).fontSize;
}, function (props) {
  return getSize(props).fontWeight;
}, function (props) {
  return props.theme.color.neutral11;
}, function (props) {
  return props.transparentAddons ? 'transparent' : props.theme.input.addon.backgroundColor;
}, function (props) {
  return getSize(props).border;
}, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return props.disabled && (0, _ykbStyledComponents.css)(["color:", ";border-color:", ";"], function (props) {
    return props.theme.input.disabled.color;
  }, function (props) {
    return props.theme.input.disabled.borderColor;
  });
}, _StyledButton.default, _StyledButton.default, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return getSize(props).borderRadius;
}, _StyledButton.default, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return getSize(props).borderRadius;
});
var CopyButtonWrapper = exports.CopyButtonWrapper = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-8"
})(["position:relative;display:table-cell;vertical-align:middle;padding:0 ", " 0 1px;transition:all 0.3s;width:1px;"], function (props) {
  return getSize(props).paddingHorizontal;
});
var CopyButton = exports.CopyButton = (0, _ykbStyledComponents.default)(_Button.default).withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-9"
})(["display:inline-block;vertical-align:middle;margin:-1px -12px -1px -10px;padding:0 10px;border:0;border-radius:0 ", " ", " 0;background-color:", " !important;cursor:pointer;&:hover{background-color:", " !important;}&:active{background-color:", " !important;}&:focus,&:hover{z-index:1;border-right-width:1px;}"], function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return getSize(props).borderRadius;
}, function (props) {
  return props.theme.color.primary6;
}, function (props) {
  return props.theme.color.primary7;
}, function (props) {
  return props.theme.color.primary8;
});
var CopyIcon = exports.CopyIcon = (0, _ykbStyledComponents.default)(_Icon.default).withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-10"
})(["font-size:", ";"], function (props) {
  return getSize(props).copyIconSize;
});
var ChildrenWrapper = exports.ChildrenWrapper = _ykbStyledComponents.default.div.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-11"
})([""]);
var ViewModeChildren = exports.ViewModeChildren = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-12"
})([""]);
var ViewModePrefix = exports.ViewModePrefix = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-13"
})([""]);
var ViewModeSuffix = exports.ViewModeSuffix = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-14"
})([""]);
var ViewModeWrapper = exports.ViewModeWrapper = _ykbStyledComponents.default.span.withConfig({
  componentId: "ykb-ui__sc-1fuqoxz-15"
})(["display:flex;", "{padding-right:", ";}", "{margin-left:auto;}"], ViewModePrefix, function (props) {
  return getSize(props).paddingHorizontal;
}, ViewModeSuffix);